import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarteirinhaRoutingModule } from './carteirinha.routing.module';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { QRCodeModule } from 'angularx-qrcode';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { FormCarteirinhaComponent } from './form-carteirinha/form-carteirinha.component';

@NgModule({
  declarations: [
    FormCarteirinhaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    CarteirinhaRoutingModule,
    InputTextModule,
    InputMaskModule,
    QRCodeModule
  ]
})
export class CarteirinhaModule { }
